var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.574,
    height: 38.227,
    viewBox: "0 0 32.574 38.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M991.226,632.667h-.1a2.284,2.284,0,0,0-2.277,2.278v9.922a2.283,2.283,0,0,0,2.277,2.28h.1a2.283,2.283,0,0,0,2.276-2.28v-9.922A2.286,2.286,0,0,0,991.226,632.667Zm3.367,16.029a2.1,2.1,0,0,0,2.092,2.091h2.236v5.359a2.284,2.284,0,0,0,2.279,2.282h.09a2.283,2.283,0,0,0,2.28-2.282v-5.359h3.13v5.359a2.288,2.288,0,0,0,2.28,2.282h.09a2.283,2.283,0,0,0,2.28-2.282v-5.359h2.24a2.1,2.1,0,0,0,2.09-2.091V633.03H994.593V648.7Zm15.8-25.166,1.77-2.744a.367.367,0,0,0-.11-.522.371.371,0,0,0-.52.111l-1.84,2.839a12.165,12.165,0,0,0-9.11,0l-1.834-2.839a.379.379,0,0,0-.636.411l1.778,2.744a9,9,0,0,0-5.365,7.934c0,.208.013.414.031.618h21.166q.03-.306.03-.618a9,9,0,0,0-5.363-7.934Zm-10.16,4.913a1.017,1.017,0,1,1,.721-.3,1.018,1.018,0,0,1-.721.3Zm9.81,0a1.019,1.019,0,1,1,.72-.3,1.018,1.018,0,0,1-.72.3Zm9.1,4.224h-.09a2.289,2.289,0,0,0-2.28,2.278v9.922a2.288,2.288,0,0,0,2.28,2.28h.1a2.281,2.281,0,0,0,2.27-2.28v-9.922a2.282,2.282,0,0,0-2.283-2.278Z",
    transform: "translate(-988.849 -620.202)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android-icon.ffcf064eb929b85eeb89b838333c6df0.svg";
export { ForwardRef as ReactComponent };